import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuth } from '../composables/useAuth';

import Login from '../pages/auth/Login.vue'
import UserManagement from '../pages/UserManagement.vue';
import Analytics from '../pages/Analytics.vue'
import Settings from '../pages/Settings.vue'
import Reports from '../pages/Reports.vue'

const ROUTE_NAMES = {
	USER: 'userManagement',
	ANALYTICS: 'analytics',
	SETTINGS: 'settings',
	REPORTS: 'reports',
	LOGIN: 'login',
}

const routes = [
	{
		path: '/',
		component: () => import('../layouts/MainLayout.vue'),
		children: [
			{ path: '', name: ROUTE_NAMES.USER, component: UserManagement },
		],
		meta: { requiresAuth: true },
	},
	{
		path: '/analytics',
		component: () => import('../layouts/MainLayout.vue'),
		children: [
			{ path: '', name: ROUTE_NAMES.ANALYTICS, component: Analytics },
		],
		meta: { requiresAuth: true },
	},
	{
		path: '/settings',
		component: () => import('../layouts/MainLayout.vue'),
		children: [
			{ path: '', name: ROUTE_NAMES.SETTINGS, component: Settings },
		],
		meta: { requiresAuth: true },
	},
	{
		path: '/reports',
		component: () => import('../layouts/MainLayout.vue'),
		children: [
			{ path: '', name: ROUTE_NAMES.REPORTS, component: Reports },
		],
		meta: { requiresAuth: true },
	},
	{
		path: '/login',
		component: () => import('../layouts/AuthLayout.vue'),
		children: [
			{ path: '', name: ROUTE_NAMES.LOGIN, component: Login },
		],
		meta: { requiresAuth: false },
	},
	{
		path: '/:catchAll(.*)*',
		component: UserManagement,
	},
]

// function isTokenExpired(token) {
// 	try {
// 		const [, payload] = token.split('.');
// 		const decoded = JSON.parse(atob(payload));
// 		return decoded.exp * 1000 < Date.now();
// 	} catch {
// 		return true;
// 	}
// }

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

router.beforeEach((to, from, next) => {
	const { isAuthenticated } = useAuth();
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
	const isLoginPage = to.name === ROUTE_NAMES.LOGIN;

	if (requiresAuth && !isAuthenticated.value) {
		next({ name: ROUTE_NAMES.LOGIN });
	} else if (isLoginPage && isAuthenticated.value) {
		next({ name: ROUTE_NAMES.USER });
	} else {
		next();
	}
});

export default router;